/* eslint-disable simple-import-sort/imports */
import { SearchMicroViewDisposeChannel, SearchMicroViewRenderChannel } from '@tableau/search-microview-communication-channels';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { style } from 'typestyle';

import { CommonStyles } from '~src/common/react/CommonStyles';

import { enterSpace } from '~src/spacesPlatform/actions/EnterSpaceAction';
import { SpaceInfo, SpaceItemForNonEntitySpace } from '~src/spacesPlatform/state/SpaceInfo';

import { MapDispatchToProps } from '../../app/utils/ConnectUtils';
import { Messages } from '../../codegen/Localize';
import { SearchMicroViewHostService } from '../services/SearchMicroViewHostService';

export type SearchMicroViewOwnProps = {};
export type SearchMicroViewHostProps = SearchMicroViewOwnProps & SearchMicroViewHostDispatchProps;

export const ErrorUITestId = 'SearchMicroViewHostError';

const errorStyles = style({
    fontSize: '14px',
    textAlign: 'center',
    lineHeight: '1.5',
    position: 'absolute',
    left: '50%',
    top: '40%',
    transform: 'translate(-50%,-50%)',
    $nest: {
        '.title': {
            fontSize: '18px',
            marginBottom: '16px',
            lineHeight: '1.5',
            color: CommonStyles.Colors.Grey51,
        },
        '.sub-title': {
            fontSize: '14px',
            marginBottom: '16px',
            color: CommonStyles.Colors.Grey77,
        }
    },
});


export function SearchMicroViewHost(props: SearchMicroViewHostProps): JSX.Element {
    const rootElementRef = React.useRef(null);
    const { enterSpace } = props;

    const [error, setError] = React.useState(false);

    React.useEffect(() => {
        SearchMicroViewHostService.instance.bootstrapMicroView();

        if (rootElementRef && rootElementRef.current) {
            const spaceInfo: SpaceInfo = {
                item: SpaceItemForNonEntitySpace,
                spaceType: 'search',
                subspaceName: 'views'
            };
            enterSpace(spaceInfo);

            SearchMicroViewHostService.instance.bundleReadyPromise.then(() => {
                (new SearchMicroViewRenderChannel()).call();
            }, () => {
                setError(true);
            });
        }

        return () => {
            (new SearchMicroViewDisposeChannel()).call();
        };
    }, [enterSpace]);

    return error ? <div className={errorStyles} data-tb-test-id={ErrorUITestId}>
        <div className='title'>{Messages.searchMicroviewErrorHeader()}</div>
        <div className='sub-title'>{Messages.searchMicroviewErrorMessage()}</div>
    </div>
        : <div id='SearchMicroViewHost' ref={rootElementRef}>
        </div>;
}

export interface SearchMicroViewHostDispatchProps {
    readonly enterSpace: (spaceInfo: SpaceInfo) => void;
}

const mapDispatchToProps: MapDispatchToProps<SearchMicroViewHostDispatchProps> = (dispatch) => bindActionCreators({
    enterSpace,
}, dispatch);

export const ConnectedSearchMicroViewHost: React.ComponentClass<SearchMicroViewOwnProps> = connect(null, mapDispatchToProps)(SearchMicroViewHost);
